import { useState } from "react";
import { toast } from "sonner";

interface UseFormSubmissionProps<T> {
  submitFn: (data: T) => Promise<void>;
  successMessage?: string;
  onSuccess?: () => void;
}

export function useFormSubmission<T>({
  submitFn,
  successMessage = "Submitted successfully!",
  onSuccess
}: UseFormSubmissionProps<T>) {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (data: T) => {
    setIsLoading(true);
    try {
      await submitFn(data);
      toast.success(successMessage);
      if (onSuccess) onSuccess();
    } catch (error: any) {
      console.error("Submission error:", error);
      toast.error("Submission Failed", {
        description: error.message || "Please try again later.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    handleSubmit
  };
}
